import NP from 'number-precision'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['getliveshow', 'getBettingStatus']),
    liveshowPath () {
      const name = this.$route.name
      return this.routerSplit(name) == 'liveshow'
    },
    liveshowAllPath () { 
      const name = this.$route.name
      return this.routerSplit(name) == 'liveshowAll'
    },
    livshowName() {
      const name = this.$route.name
      return this.routerSplit(name, 1)
    },
    cloce () {
      let status
      if (this.livshowName == 'scode') {
        status = ['1', '3'].some(it => it == this.getBettingStatus)
      } else {
        status = this.getBettingStatus == '1'
      }
      return { 'close': !status }
    }
  },
  methods: {
    routerSplit(value, index = 0) {
      return value.split('-')[index]
    },
    classColor(index) {
      let result
      switch (index) {
        case 1:
          result = { 'red-text': true }
          break;
        case 2:
          result = { 'blue-text': true }
          break;
        case 3:
          result = { 'green-text': true }
          break;
      }
      return result
    },
    strip (val) {
      return NP.strip(Number(val))
    }
  }
}